import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { injectIntl } from 'react-intl'
import { inlineLexer } from 'marked'
import { findLocalized } from '../utils'

import eventoImg from '../images/contents/evento.jpg'
import eventoImgSm from '../images/contents/evento-sm.jpg'

const Evento = ({ intl: { locale } }) => (
  <StaticQuery
    query={graphql`
      query {
        workshop: file(relativePath: {eq: "iic-icon.png"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }   
        allEventoYaml{
          edges{
            node{
              title
              subject
              text
              lang
            }
          }
        }    
      }
    `}
    render={data => {
      const { title, subject, text } = findLocalized(data.allEventoYaml, locale);
      return (
        <section className="section evento" >
          <picture className="evento__img">
            <source media="(min-width: 768px)" srcSet={eventoImg} />
            <img src={eventoImgSm} alt={title} />
          </picture>
          <div className="evento__text">
            <div className="evento__title">{title}</div>
            <div className="evento__subject">{subject}</div>
            <div className="evento__desc" dangerouslySetInnerHTML={{__html: inlineLexer(text, [])}}></div>
            {/* <a onClick="trackOutboundLink('https://www.eventbrite.it/e/biglietti-intranet-italia-day-43748794823','iscriviti','partecipa');return false;" href="https://www.eventbrite.it/e/biglietti-intranet-italia-day-43748794823" title="Partecipa" className="btn-cta btn-style-2">Partecipa</a> */}
          </div>
        </section>
      )
    }}
  />
);

export default injectIntl(Evento);
